<template>
  <div class="grid_wrapper">
    <div class="box" @click="handlerClick(index, item)" :class="{active: activeTab === index}" v-for="(item, index) in list" :key="index">
      <div class="boxcontent">
        <!--<div>{{item.prsbmbegtime}}</div>-->
        <!--<div>{{item.prsbmendtime}}</div>-->
          <!--<div>{{item.prsbjbegtime}}</div>-->
            <!--<div>{{item.prsbjendtime}}</div>-->
        <div class="title">{{item.projectname}}</div>
        <div class="company">采购人：<span>{{item.comfullname}}</span></div>
        <div class="time">发布时间：<span>{{item.projecttime}}</span></div>
      </div>
      <div class="detailbtn" v-if="childActiveTab.datafrom === '2' || (childActiveTab.datafrom !== '2' && !item.btnstatusdesc)">查看详情</div>
      <!--'1 距离报名开始还剩(即将报名)'-->
      <!--'2 距离报名结束还剩(正在报名)'-->
      <!--'3 距离报价开始还剩(即将报价)'-->
      <!--'4 距离报价结束还剩(正在报价)'-->
      <!--'5 已完成'-->
      <div class="grid_btn" v-if="item.btnstatus && item.btnstatusdesc">
        <div class="btn_bg orange" :class="{green: item.btnstatus === 2 || item.btnstatus === 4 || item.btnstatus === 5, orange:item.btnstatus === 1 || item.btnstatus === 3, gray: item.btnstatus > 5}"></div>
        <div class="btn" :class="{being: item.btnstatus === 2 || item.btnstatus === 4 || item.btnstatus === 5,ended: item.btnstatus > 5}">
          <span>{{item.btnstatusdesc}}</span>
        </div>
      </div>
      <div class="countdown grid_progress" v-if="item.btnstatus && item.alertmsg">
        <div v-if="item.btnstatus && item.alertmsg">
        <el-progress v-if="item.percentage > 0" :text-inside="true" :stroke-width="8" :percentage="item.percentage" :show-text="false"></el-progress>
        </div>
          <div class="time" >
          <span v-if="item.btnstatus && item.alertmsg">{{item.alertmsg}}:</span><count-down v-if="item.btnstatus && item.alertmsg" @change="cuntDownChange" :index="index" :enddate="item.enddate ? item.enddate : nowdate"></count-down>
        </div>
      </div>
      <div v-else class="empty"></div>
    </div>
  </div>
</template>

<script>
  import {mapGetters} from 'vuex'
  import CountDown from './CountDown'
  import dayjs from 'dayjs'
  import request from '@/utils/request'
  export default {
    name: "ProjectGrid",
    components: {CountDown},
    props: {
      list: {
        default:[]
      }
    },
    data () {
      return {
        activeTab: '',
        nowdate: ''
      }
    },
    created () {
      this.nowdate = request({
        method: 'get',
        url: 'xtgl/sysdata'
      })
    },
    methods: {
      async cuntDownChange (time, index) {
        let item = this.list[index]
        // this.percentage = (((end - this.p_now)-time) / (end - this.p_now)) * 100
        this.list[index].percentage = (time / (dayjs(item.enddate).valueOf() - dayjs(item.begindate).valueOf())) * 100
        if (this.list[index].percentage <= 0) {
          let btnstatus = 0
          let now = await request({
            method: 'get',
            url: 'xtgl/sysdata'
          })
          now = dayjs(now).valueOf()
          if (now < dayjs(item.prsbmbegtime).valueOf()) {
            btnstatus = 1
          } else if (now > dayjs(item.prsbmbegtime).valueOf() && now < dayjs(item.prsbmendtime).valueOf()) {
            btnstatus = 2
          } else if (dayjs(item.prsbmendtime) < now && now < dayjs(item.prsbjbegtime).valueOf()) {
            btnstatus = 3
          } else if (now > dayjs(item.prsbjbegtime).valueOf() && now < dayjs(item.prsbjendtime).valueOf()) {
            btnstatus = 4
          } else {
            btnstatus = 5
          }
          if (item.projectstatus == '40') {
            btnstatus = 6
          }
          if (btnstatus === 1) {
            // && Number(item.projectstatus) === 20
            this.list[index].btnstatusdesc = '即将报名'
            this.list[index].alertmsg = '离报名开始剩'
            this.list[index].begindate = item.projecttime
            this.list[index].enddate = item.prsbmbegtime
          } else if (btnstatus === 2) {
          // && Number(item.projectstatus) === 20
            this.list[index].btnstatusdesc = '正在报名'
            this.list[index].alertmsg = '离报名结束剩'
            this.list[index].begindate = item.prsbmbegtime
            this.list[index].enddate = item.prsbmendtime
          } else if (btnstatus === 3) {
          // && Number(item.projectstatus) === 20
            this.list[index].btnstatusdesc = '即将报价'
            this.list[index].alertmsg = '离报价开始剩'
            this.list[index].begindate = item.prsbmendtime
            this.list[index].enddate = item.prsbjbegtime
          } else if (btnstatus === 4) {
          // && Number(item.projectstatus) === 30
            this.list[index].btnstatusdesc = '正在报价'
            this.list[index].alertmsg = '离报价结束剩'
            this.list[index].begindate = item.prsbjbegtime
            this.list[index].enddate = item.prsbjendtime
          } else {
            this.list[index].btnstatusdesc = '待评审'
            this.list[index].alertmsg = ''
          }
          if (btnstatus === 6) {
            this.list[index].btnstatusdesc = '已完成'
            this.list[index].alertmsg = ''
          }
          if (this.list[index].btnstatusdesc) {
            this.list[index].btnstatus = btnstatus
            this.list[index].percentage = 100
          }
        }
      },
      handlerClick (index, item) {
        this.activeTab = index
        let obj = this.childActiveTab
        obj.last = item
        this.$store.commit('changeState', {'childActiveTab': obj})
        // let menu = this.menus.find(v => v.index === 1)
        let menu = this.menus[1]
        // if (!this.childActiveTab.datawhere) {
        //   menu.datawhere = item.projectstatus
        //   this.childActiveTab.datawhere = item.projectstatus
        // }
        this.$store.commit('changeState', { 'parentActiveTab': menu})
        // this.$router.push({name: menu.url, query: {id: menu.index}})
        let {href} = this.$router.resolve({name: menu.url, query: {id: menu.index}})
        window.open(href, '_blank')
        console.log('网格点击', this.activeTab, this.childActiveTab)
      }
    },
    computed: {
      ...mapGetters(['menus', 'childActiveTab'])
    }
  }
</script>

<style lang="scss" scoped>
  @import '../../styles/variables';
.grid_wrapper {
  background-color: $color-bg-white;
  /*justify-content: center;*/
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  .box {
    display: flex;
    flex-direction: column;
    border: 1px solid $color-box-gray;
    width: 30%;
    height: 278px;
    margin: 0 12px 20px;
    padding: 20px 10px 25px;
    color: $color-black;
    .boxcontent {
      flex: 1;
      .title {
        line-height: 23px;
        min-height: 46px;
        max-height: 46px;
        font-size: $fontsize-large;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        overflow: hidden;
      }
      .company {
        color: $color-dark-gray;
        font-size: $fontsize-medium-s;
        padding-top: 15px;
        display: -webkit-box;
        -webkit-line-clamp: 1;
        -webkit-box-orient: vertical;
        overflow: hidden;
      }
      .time {
        color: $color-dark-gray;
        font-size: $fontsize-medium-s;
        padding-top: 10px;
      }
    }
    .detailbtn {
      color: $color-orange;
    }
    .grid_btn {
      position: relative;
      left: -16px;
      top: -32px;
      .btn {
        text-align: center;
        /*height: 33px;*/
        width: 105px;
        color: #FFFFFF;
        font-size: $fontsize-large-x;
        padding: 7px 0px;
        background-color: $color-orange;
      }
      .being {
        background-color: $color-being-green;
      }
      .ended {
        background-color: $color-orange#909399;
      }
      .btn_bg {
        position: relative;
        left: 0px;
        top: 0px;
        width:0;
        height:0;
        background-color: transparent;
        border-right:0px solid transparent;
        border-left:6px solid transparent;
      }
      .orange {
        border-bottom:6px solid #c44608;
      }
      .green {
        border-bottom:6px solid #318B04;
      }
      .gray {
        border-bottom:6px solid #c44608;
      }
    }
    .countdown {
      color: $color-black;
      font-size: $fontsize-medium;
      .time {
        padding-top: 23px;
        display: flex;
        align-items: center;
        justify-content: center;
        span {
          /*background-color: red;*/
          margin-right: 1px;
        }
      }

    }
    .empty {
      padding-top: 50px;
    }
  }
  div.box:hover {
    cursor: pointer;
    border: 1px solid $color-orange;
    color: $color-orange;
  }
  .active {
    border: 1px solid $color-orange;
    color: $color-orange;
  }
}
</style>